import { getWorkOrderParts } from "@/pages/work-orders/repositorie/WorkOrdersRepositorie";
import { useWorkOrderModalsContext } from "@/shared/work-orders-modals/context/work-order-modals.context";
import { get } from "lodash-es";

type Props = {
	setIsWorkOrderPartsLoading: (isLoading: boolean) => void;
	setWorkOrderPartsError: (err: string) => void;
	WorkOrderId: number | null;
};

export const useSearchWorkOrderParts = ({
	WorkOrderId,
	setIsWorkOrderPartsLoading,
	setWorkOrderPartsError,
}: Props) => {
	const {
		actions: { setWorkOrderPartsList },
	} = useWorkOrderModalsContext();

	return async () => {
		setWorkOrderPartsList([]);
		setIsWorkOrderPartsLoading(true);
		const res = await getWorkOrderParts(WorkOrderId as number);
		if (res.ok) {
			const rowsSource = get(res, "data.tables[0].rows", []);
			setWorkOrderPartsList(rowsSource);
			setIsWorkOrderPartsLoading(false);
		} else {
			setIsWorkOrderPartsLoading(false);
			setWorkOrderPartsError(res.message);
		}
	};
};
